'use client';

import { InverseHeader } from '@jouzen/ecom-components/layout';
import { usePathname } from 'next/navigation';

import { EventType } from '@/analytics/types';
import LandingPageHero from '@/app/components/LandingPage/LandingPageHero';
import { STORE_POP_PATHNAME } from '@/app/consts/pathnames';

const ExtendHero = () => {
  const path = usePathname();

  const handleCtaClick = () => {
    void window.ouraAnalytics.track(EventType.CTAClicked, {
      cta: 'shop_now',
      action: 'go_to_pdp',
      location: 'hero_module',
      module: 'hero_module',
      path,
    });
  };

  return (
    <InverseHeader enter>
      <LandingPageHero
        backgroundImage={{
          alt: '',
          srcSet: [
            {
              media: '(max-width: 1023px)',
              src: 'extend/extend-hero-mobile.jpg?fit=crop&crop=focalpoint&fp-x=0.5&fp-y=0.6&fp-z=1.5',
            },
            {
              media: '(min-width: 1024px)',
              src: 'extend/extend-hero-desktop',
            },
          ],
        }}
        backgroundProps={{
          color: 'sandstone-200',
          gradients: [],
        }}
        copy="extend_hero_subtitle"
        eyebrow="extend"
        cta={{
          href: STORE_POP_PATHNAME,
          label: 'call_to_action_button_text',
          onClick: handleCtaClick,
        }}
        data-cy="extend-hero"
        title="extend_hero_title"
        titleProps={{
          indentation: 'pl-[10rem] md:pl-[15rem] lg:pl-[20rem]',
          typographyProps: {
            className: 'lg:en:whitespace-nowrap',
          },
        }}
        textColor="text-sandstone-200"
      />
    </InverseHeader>
  );
};

export default ExtendHero;
